import { render, staticRenderFns } from "./ChartFundValue.vue?vue&type=template&id=0482de6b"
import script from "./ChartFundValue.vue?vue&type=script&lang=js"
export * from "./ChartFundValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports